import React from 'react';
import { createPortal } from 'react-dom';
import { StatusIcon, ChevronDownIcon } from '../icons';

/**
 * StatusDropdown Component
 * Dropdown for changing status of selected missions
 */
const StatusDropdown = ({
  isActive,
  onToggle,
  onStatusChange,
  statuses,
  menuStyle,
  buttonRef,
}) => {
  return (
    <div className="bulk-actions-toolbar__dropdown-container">
      <button
        ref={buttonRef}
        className={`bulk-actions-toolbar__btn ${isActive ? 'bulk-actions-toolbar__btn--active' : ''}`}
        onClick={(e) => onToggle('status', e.currentTarget)}
        title="Change status"
      >
        <StatusIcon />
        <span>Status</span>
        <ChevronDownIcon />
      </button>
      {isActive && createPortal(
        <div className="bulk-actions-toolbar__menu" style={menuStyle}>
          {statuses.map(status => (
            <button
              key={status.id}
              className="bulk-actions-toolbar__menu-item"
              onClick={() => onStatusChange(status.id)}
            >
              <span className="bulk-actions-toolbar__status-dot" style={{ background: status.color }} />
              <span>{status.name}</span>
            </button>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
};

export default StatusDropdown;
